const getPlanEndDate = (planCode) => {
  const currentDate = new Date();

  switch (planCode) {
    case '1Y':
      currentDate.setFullYear(currentDate.getFullYear() + 1);
      break;

    case '6M':
      currentDate.setMonth(currentDate.getMonth() + 6);
      break;

    case '3M':
      currentDate.setMonth(currentDate.getMonth() + 3);
      break;

    default:
      currentDate.setFullYear(currentDate.getFullYear() + 1);
  }

  return currentDate.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
};

export default getPlanEndDate;
